import React, {Component} from 'react';
import {List, ListItem, makeSelectable} from 'material-ui/List';
import PropTypes from 'prop-types';
import Subheader from 'material-ui/Subheader';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from "material-ui/RaisedButton";
import {Card, CardText} from 'material-ui/Card';
import * as admExp from '../Reports/AdminExports';
import {adminCardStyle} from '../containers/AdminHomepage';
import {SECTION_TITLES} from './AnswersList';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';

const gridWrapperStyle = {
  ...adminCardStyle,
  border: "1px solid grey",
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr",
  gridTemplateAreas:
         `"rptList rptList rptDesc rptDesc rptDesc dlBtn"
          "rptList rptList colList colList sectList sectList"
          "rptList rptList colList colList sectList sectList"`,
  gridGap: "15px",
  backgroundColor: "white",
  padding:"8px"

}

const listItemStyle = {
  paddingTop:5,
  paddingBottom:5
}

const chkBoxStyle = {
  top:0
}

const subheadStyle = {
  fontFamily:"Roboto, sans-serif",
  fontWeight:"500",
  color:"black",
  backgroundColor:"rgb(232, 232, 232)",
  borderBottom:"1px solid grey"
}

let SelectableList = makeSelectable(List);

function wrapState(ComposedComponent) {
  return class SelectableList extends Component {
    static propTypes = {
      children: PropTypes.node.isRequired,
      defaultValue: PropTypes.number.isRequired,
    };

    componentWillMount() {
      this.setState({
        selectedIndex: this.props.defaultValue,
      });
    }

    handleRequestChange = (event, index) => {
      this.setState({
        selectedIndex: index,
      });
    };

    render() {
      return (
        <ComposedComponent
          value={this.state.selectedIndex}
          onChange={this.handleRequestChange}
          style={this.props.style}
        >
          {this.props.children}
        </ComposedComponent>
      );
    }
  };
}

SelectableList = wrapState(SelectableList);


class AdminExports extends React.Component {
  constructor(props){
    super(props);

    //select first export to init state with
    var rptInfo = admExp.getReport(admExp.Q_ORDER_SECTIONS_RPT);
    this.state = {
      description: rptInfo.description,
      columns: rptInfo.columns,
      selectedCols: rptInfo.columns,
      sections: rptInfo.sections,
      selectedSections: rptInfo.sections,
      multiSections: rptInfo.multiSections,
      downloadFunc: rptInfo.downloadFunc
    };
  }

  render() {
    var selCols = this.state.selectedCols;
    var selSections = this.state.selectedSections;
    var downloadFunc = this.state.downloadFunc;
    var columnListItems = this.state.columns.map((col) => {
      return(
        <ListItem key={col} primaryText={col} style={listItemStyle} leftCheckbox={<Checkbox style={chkBoxStyle} checked={this.state.selectedCols.includes(col)} onCheck={this.onCheckCol.bind(this, col)} />} />
      )
    })

    var sections = this.state.sections.map((section) => {
      if (this.state.multiSections) {
        return(
          <ListItem key={"exports" + section} primaryText={SECTION_TITLES[section]} style={listItemStyle} leftCheckbox={<Checkbox style={chkBoxStyle} checked={this.state.selectedSections.includes(section)} onCheck={this.onCheckSection.bind(this, section)} />} />
        )
      } else{
        var lbl = section.split(",").reduce((acc, cur) => {return (acc + SECTION_TITLES[cur] + ", ")}, "")
        lbl = lbl.substring(0, lbl.length - 2) //remove extra ", " at end of label
        return(
          <RadioButton key={"exports" + section} value={section} label={lbl} />
        )
      }
    })

    return(
      <React.Fragment>
        <div style={gridWrapperStyle}>
          <SelectableList key="reportsCol" defaultValue={1} style={{overflow:"auto", gridArea:"rptList", backgroundColor:"white", border: "2px solid grey"}}>
            <Subheader style={subheadStyle}>CSV Export Name</Subheader>
            <ListItem key="rpt1" value={1} primaryText="Questionnaire Order by Section Answered" onClick={this.onReportSelect.bind(this, admExp.Q_ORDER_SECTIONS_RPT)}/>
            <ListItem key="rpt2" value={2} primaryText="Question Order" onClick={this.onReportSelect.bind(this, admExp.Q_ORDER_RPT)}/>
            <ListItem key="rpt3" value={3} primaryText="Caveats by Option and Question" onClick={this.onReportSelect.bind(this, admExp.CAV_LINKS_RPT)} />
            <ListItem key="rpt4" value={4} primaryText="Criteria by Option and Question" onClick={this.onReportSelect.bind(this, admExp.CRIT_LINKS_RPT)} />
            <ListItem key="rpt5" value={5} primaryText="Options" onClick={this.onReportSelect.bind(this, admExp.OPT_RPT)} />
            <ListItem key="rpt6" value={6} primaryText="Questions" onClick={this.onReportSelect.bind(this, admExp.Q_RPT)} />
            <ListItem key="rpt7" value={7} primaryText="Answers" onClick={this.onReportSelect.bind(this, admExp.ANS_RPT)}/>
            <ListItem key="rpt8" value={8} primaryText="Caveats" onClick={this.onReportSelect.bind(this, admExp.CAV_RPT)}/>
            <ListItem key="rpt9" value={9} primaryText="Static Caveats" onClick={this.onReportSelect.bind(this, admExp.STAT_CAV_RPT)} />
            <ListItem key="rpt10" value={10} primaryText="Criteria" onClick={this.onReportSelect.bind(this, admExp.CRIT_RPT)}/>
          </SelectableList>

          <Card style={{gridArea:"rptDesc", backgroundColor:"white", border: "2px solid grey"}}>
            <Subheader style={subheadStyle}>CSV Desctiption</Subheader>
            <CardText>
              {this.state.description}
            </CardText>
          </Card>

          <div style={{gridArea:"colList", backgroundColor:"white", border: "2px solid grey"}}>
            <Subheader style={subheadStyle}>Columns for CSV</Subheader>
            <List>
              {columnListItems}
            </List>
          </div>

          <div style={{gridArea:"sectList", backgroundColor:"white", border: "2px solid grey"}}>
            <Subheader style={subheadStyle}>Sections for CSV</Subheader>
            {this.state.multiSections ?
              <List>
                {sections}
              </List> :
              <RadioButtonGroup name="sectionsRadio" style={{marginLeft:10,marginTop:10}} onChange={this.onRadioSelect.bind(this)} defaultSelected={this.state.sections[0]}>
                {sections}
              </RadioButtonGroup>
            }
          </div>
            {
              (this.state.description.length > 0) ? <RaisedButton label={"Download CSV"} style={{gridArea:"dlBtn", justifySelf: "center", alignSelf:"center"}} onClick={function() {downloadFunc(selCols, selSections)}} /> : ""
            }

        </div>



      </React.Fragment>
    );
  }

  onReportSelect(report){
    var rptInfo = admExp.getReport(report);
    this.setState({
      description: rptInfo.description,
      columns: rptInfo.columns,
      selectedCols: rptInfo.columns,
      sections: rptInfo.sections,
      selectedSections: rptInfo.sections,
      multiSections: rptInfo.multiSections,
      downloadFunc: rptInfo.downloadFunc
    });
  }

  onRadioSelect(e, section){
    this.setState({
      selectedSections: [section]
    })
  }

  onCheckCol(col){
    var index = this.state.selectedCols.indexOf(col);
    var newItems = this.state.selectedCols.slice();
    if(index === -1){
      //item not in list, therefore checking box and need to add ID to selectedItems
      newItems.push(col);
    }else{
      //item in the list, unchecking item, remove from list
      newItems.splice(index, 1);
    }
    this.setState({
      selectedCols: newItems
    })
  }

  onCheckSection(section){
    var index = this.state.selectedSections.indexOf(section);
    var newItems = this.state.selectedSections.slice();
    if(index === -1){
      //item not in list, therefore checking box and need to add ID to selectedItems
      newItems.push(section);
    }else{
      //item in the list, unchecking item, remove from list
      newItems.splice(index, 1);
    }
    this.setState({
      selectedSections: newItems
    })
  }
}

export default AdminExports;
